export default __webpack_public_path__ + "static/media/HGP_Logo.d776a79b.png";